export type Role = 'display' | 'player';

export interface DeviceEnv {
  userAgent: string;
  maxTouchPoints: number;
  coarsePointer: boolean;
  screenWidth: number;
}

const PHONE_UA = /iPhone|iPod|Android.*Mobile|Mobile Safari/;

export function detectRole(env: DeviceEnv): Role {
  if (PHONE_UA.test(env.userAgent)) return 'player';
  if (env.coarsePointer && env.screenWidth < 900) return 'player';
  return 'display';
}

/** `?as=host|player` wins; otherwise the stored value (`display`/`player`). */
export function roleOverride(search: string, stored: string | null): Role | null {
  const as = new URLSearchParams(search).get('as');
  if (as === 'host' || as === 'display') return 'display';
  if (as === 'player') return 'player';
  if (stored === 'display' || stored === 'player') return stored;
  return null;
}
